// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Information_infoWrapper__nRB3V","infoImgWrapper":"Information_infoImgWrapper__vCJg1"};